// Service API
import api from './api';

const serviceAPI = {
  getAllServices: (filters) => api.get('/services', { params: filters }),
  getServiceById: (id) => api.get(`/services/${id}`),
  getServicesByCategory: (category) => api.get(`/services/category/${category}`),
  createService: (serviceData) => api.post('/services', serviceData),
  updateService: (id, serviceData) => api.put(`/services/${id}`, serviceData),
  deleteService: (id) => api.delete(`/services/${id}`),
};

export default serviceAPI;
